export enum LeadTabTypes {
    ListView = "ListView",
    ActivityView = "ActivityView",
    ActivityCalendar = "ActivityCalendar",
    ActivityTemplates = "ActivityTemplates",
    Proposals = "Proposals",
    ProposalTemplates = "ProposalTemplates",
    Map = "Map",
}

export function getLeadTabUrlSegment(tab: LeadTabTypes): string {
    if (tab === LeadTabTypes.ActivityView) {
        return "activities";
    } else if (tab === LeadTabTypes.ActivityCalendar) {
        return "calendar";
    } else if (tab === LeadTabTypes.ActivityTemplates) {
        return "activityTemplates";
    } else if (tab === LeadTabTypes.Map) {
        return "map";
    } else if (tab === LeadTabTypes.Proposals) {
        return "proposals";
    } else if (tab === LeadTabTypes.ProposalTemplates) {
        return "proposalTemplates";
    }
    return "opportunities";
}

export function getLeadTabTypeFromUrl(pathname: string): LeadTabTypes {
    const urlParts = pathname.split("/").filter(Boolean);
    const leadsIndex = urlParts.findIndex((part) => part.toLowerCase() === "leads");
    const tab = leadsIndex >= 0 ? urlParts[leadsIndex + 1] : undefined;
    if (tab === "opportunities") {
        return LeadTabTypes.ListView;
    } else if (tab === "map") {
        return LeadTabTypes.Map;
    } else if (tab === "activities") {
        return LeadTabTypes.ActivityView;
    } else if (tab === "calendar") {
        return LeadTabTypes.ActivityCalendar;
    } else if (tab === "activityTemplates") {
        return LeadTabTypes.ActivityTemplates;
    } else if (tab === "proposals") {
        return LeadTabTypes.Proposals;
    } else if (tab === "proposalTemplates") {
        return LeadTabTypes.ProposalTemplates;
    }
    return LeadTabTypes.ListView;
}
